export default __webpack_public_path__ + "88cf9cb0415d34a1e09e696a88cf72c6.png";